import { render, staticRenderFns } from "./y_choose_link.vue?vue&type=template&id=78ffad7d&scoped=true&"
import script from "./y_choose_link.vue?vue&type=script&lang=js&"
export * from "./y_choose_link.vue?vue&type=script&lang=js&"
import style0 from "./y_choose_link.vue?vue&type=style&index=0&id=78ffad7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ffad7d",
  null
  
)

export default component.exports